import { render, staticRenderFns } from "./BoxAverbacoes.vue?vue&type=template&id=755702c2&"
import script from "./BoxAverbacoes.vue?vue&type=script&lang=js&"
export * from "./BoxAverbacoes.vue?vue&type=script&lang=js&"
import style0 from "./BoxAverbacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports